<template>
  <div class="permission-manage">
    <div
      class="permission-tree-box"
      :class="expandedArrow ? '' : 'openTree'">
      <div class="permission-tree">
        <div class="permission-tree-header">
          <span
            class="permission-tree-header-title"
            v-show="expandedArrow"
            >功能管理</span
          >
          <div
            v-show="expandedArrow"
            class="icon">
            <i
              v-show="openSilderMenu"
              class="el-icon-arrow-up"
              @click="setAllExpand(true)"
              title="展开全部"></i>
            <i
              v-show="!openSilderMenu"
              class="el-icon-arrow-down"
              @click="setAllExpand(false)"
              title="折叠全部"></i>
          </div>
        </div>
        <div
          class="expaned"
          @click="() => (expandedArrow = !expandedArrow)">
          <i
            v-if="!expandedArrow"
            size="14"
            class="el-icon-arrow-right el-icon"></i>
          <i
            v-else
            size="14"
            class="el-icon-arrow-left el-icon"></i>
        </div>
        <div class="common-tree-box">
          <el-tree
            class="tree-primary"
            ref="tree"
            :data="treeData"
            :props="defaultProps"
            node-key="id"
            highlight-current
            :expand-on-click-node="false"
            @node-click="handleNodeClick" />
        </div>
      </div>
    </div>
    <div
      class="permission-list-box outer-page-primary"
      :style="{ width: expandedArrow ? 'calc(100% - 276px)' : '100%' }">
      <!-- <div class="permission-list-header">
        <p>权限列表</p>
      </div> -->
      <Breadcrumb
        class="header-box"
        :breadcrumbList="breadcrumbList"
        :breadcrumbClick="breadcrumbClick" />
      <div
        class="operation-box common-button-box btn-group-primary"
        v-if="
          !(
            !isChecked('Permission.Create') &&
            !isChecked('Permission.Delete') &&
            !isChecked('Permission.RoleGrant.Batch')
          )
        ">
        <el-button
          class="primary-btn gr8"
          v-if="isChecked('Permission.Create')"
          type="primary"
          size="small"
          @click="openPermissionDialog">
          新增权限
        </el-button>
        <el-button
          class="normal-btn gr8"
          v-if="isChecked('Permission.Delete')"
          size="small"
          @click="deletePermission">
          删除权限
        </el-button>
        <el-button
          class="normal-btn"
          v-if="isChecked('Permission.RoleGrant.Batch')"
          size="small"
          @click="openBatchGrantDialog">
          批量授权
        </el-button>
      </div>
      <div class="common-table-box">
        <el-table
          class="publish-table"
          highlight-selection-row
          :data="permissionList"
          @select="selectChange"
          @select-all="selectChange"
          @cell-dblclick="onCellDelClick"
          height="100%"
          ref="groupTable">
          <el-table-column
            type="selection"
            width="60" />
          <el-table-column
            label="权限名称"
            prop="menuName" />
          <el-table-column
            label="权限编码"
            prop="permissionCode" />
          <el-table-column
            label="权限说明"
            prop="remark" />
          <el-table-column
            label="类型"
            prop="menuType">
            <template v-slot="{ row }">
              {{ getMenuName(row.menuType) }}
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            label="操作"
           >
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  v-if="isChecked('Permission.Update')"
                  @click="editPermission(row)"
                  type="text"
                  size="small">
                  编辑权限
                </el-button>
                <el-button
                  v-if="isChecked('Permission.Delete')"
                  type="text"
                  size="small"
                  @click="e => deletePermission(e, row)">
                  删除权限
                </el-button>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">没有找到权限</template>
                <div class="common-button-box">
                  <el-button
                    v-if="isChecked('Permission.Create')"
                    type="primary"
                    size="small"
                    @click="openPermissionDialog">
                    新增权限
                  </el-button>
                </div>
              </bj-empty>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <PermissionDialog
      :visible="permissionDialogVisible"
      :permissionInfo="permissionInfo"
      :parentInfo="selectPermissionNode"
      :queryPermissionMenu="queryPermissionMenu"
      :closeDialog="closePermissionDialog" />
    <BatchGrantDialog
      :visible="batchGrantDialogVisible"
      :closeDialog="closeBatchGrantDialog" />
  </div>
</template>

<script>
import PermissionDialog from './components/PermissionDialog.vue'
import BatchGrantDialog from './components/BatchGrantDialog.vue'
import Breadcrumb from '@/components/module/dataManage/Breadcrumb.vue'

import { Store } from '@/utils/store'

import { getParentNode } from '@/utils/generalMethods'

import {
  getPermissionMenu,
  getSubPermissionMenu,
  deletePermissionService
} from '@/service/interface'

export default {
  data() {
    return {
      permissionName: '',
      treeData: [],
      defaultProps: {
        children: 'childNodes',
        label: 'menuName'
      },

      permissionList: [],
      selectPerssions: [],
      selectPermissionNode: {
        id: '00000000-0000-0000-0000-000000000000',
        menuName: '功能管理',
        childNodes: []
      },
      breadcrumbList: [
        { id: '00000000-0000-0000-0000-000000000000', name: '功能管理' }
      ],

      menuTypeList: [
        { label: '页面', value: 'page' },
        { label: '模块', value: 'module' },
        { label: '功能', value: 'feature' }
      ],

      permissionDialogVisible: false,
      permissionInfo: null,

      batchGrantDialogVisible: false,
      openSilderMenu: true,
      expandedArrow: true
    }
  },
  components: {
    PermissionDialog,
    BatchGrantDialog,
    Breadcrumb
  },
  created() {
    this.queryPermissionMenu()
  },
  methods: {
    queryPermissionMenu() {
      return new Promise(resolve => {
        let params = {
          roleId: null,
          menuName: ''
        }
        getPermissionMenu(params).then(response => {
          if (response.status === 200) {
            let data = response.data.data
            this.rootNodeData = data
            this.treeData = data

            let parentId = data[0].parentId
            if (this.selectPermissionNode.id) {
              parentId = this.selectPermissionNode.id
            }

            getSubPermissionMenu(parentId).then(res => {
              if (res.status === 200) {
                let result = res.data.data
                this.permissionList = result

                let selectData = this.findNodeById(this.treeData, parentId)
                if (selectData) {
                  let node = this.$refs.tree.getNode(selectData.id)
                  let parentNodes = []
                  this.getParentNode(node, parentNodes)
                  parentNodes.forEach(el => {
                    el.expanded = true
                  })
                  this.$refs.tree.setCurrentKey(selectData.id)
                }
              }
            })
            resolve()
          }
        })
      })
    },
    onCellDelClick(row, column) {
      if (column.label !== '权限名称') return
      this.permissionList = []
      let selectData = this.findNodeById(this.treeData, row.id)
      let node = this.$refs.tree.getNode(selectData.id)
      node.expanded = true
      this.$refs.tree.setCurrentKey(selectData.id)
      this.handleNodeClick(selectData, node)
    },
    handleNodeClick(data, node) {
      this.selectPermissionNode = data
      this.permissionList = data.childNodes

      let parentNodes = []
      this.getParentNode(node, parentNodes)
      parentNodes.reverse()
      let breadcrumbList = [
        { id: '00000000-0000-0000-0000-000000000000', name: '功能管理' }
      ]
      parentNodes.forEach(item => {
        let nodeData = item.data
        breadcrumbList.push({ id: nodeData.id, name: nodeData.menuName })
      })
      this.breadcrumbList = breadcrumbList
    },
    breadcrumbClick(data) {
      if (data.id === '00000000-0000-0000-0000-000000000000') {
        this.selectPermissionNode = {
          id: '00000000-0000-0000-0000-000000000000',
          menuName: '功能管理'
        }
        this.permissionList = this.rootNodeData
        this.breadcrumbList = [
          { id: '00000000-0000-0000-0000-000000000000', name: '功能管理' }
        ]
        this.$refs.tree.setCurrentKey(null)
      } else {
        let selectData = this.findNodeById(this.rootNodeData, data.id)
        let node = this.$refs.tree.getNode(selectData.id)
        this.$refs.tree.setCurrentKey(selectData.id)
        this.handleNodeClick(selectData, node)
      }
    },
    openPermissionDialog() {
      this.permissionDialogVisible = true
    },
    openBatchGrantDialog() {
      this.batchGrantDialogVisible = true
    },
    closeBatchGrantDialog() {
      this.batchGrantDialogVisible = false
    },
    deletePermission(e, permissionInfo) {
      if (permissionInfo) {
        this.$confirm(
          '确定要删除此权限吗?删除该节点及其所有子节点，及所有关联角色下的该功能',
          '删除权限',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            let params = [permissionInfo.id]
            deletePermissionService(params).then(res => {
              if (res.status === 200) {
                let data = res.data
                if (data.isSuccess) {
                  this.queryPermissionMenu().then(() => {
                    this.$message.success('删除成功!')
                  })
                }
              }
            })
          })
          .catch(() => {
            // this.$message.info('取消删除!')
          })
      } else {
        if (!this.selectPerssions.length) {
          this.$message.warning('请选择需要删除的权限！！！')
          return
        }
        this.$confirm(
          '确定要删除此权限吗?删除该节点及其所有子节点，及所有关联角色下的该功能',
          '删除权限',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            let params = this.selectPerssions.map(el => el.id)
            deletePermissionService(params).then(res => {
              if (res.status === 200) {
                let data = res.data
                if (data.isSuccess) {
                  this.queryPermissionMenu().then(() => {
                    this.$message.success('删除成功!')
                  })
                }
              }
            })
          })
          .catch(() => {
            // this.$message.info('取消删除!')
          })
      }
    },
    selectChange(selection) {
      this.selectPerssions = selection
    },
    editPermission(permissionInfo) {
      this.permissionInfo = permissionInfo
      this.permissionDialogVisible = true
    },
    closePermissionDialog() {
      this.permissionDialogVisible = false
      this.permissionInfo = null
    },
    setAllExpand(state) {
      let nodes = this.$refs.tree.store._getAllNodes()
      for (let i in nodes) {
        nodes[i].expanded = state
      }
      this.openSilderMenu = !this.openSilderMenu
    },
    getMenuName(menuType) {
      let find = this.menuTypeList.find(el => el.value === menuType)
      return `${find.label}`
    },
    findNodeById(data, id) {
      for (const node of data) {
        if (node.id === id) return node
        if (node.childNodes && node.childNodes.length) {
          const res = this.findNodeById(node.childNodes, id)
          if (res) return res
        }
      }
      return null
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getParentNode
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';

.expaned {
  width: 24px;
  height: 40px;
  border-radius: 16px;
  background-color: var(--aside-arrow-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  border: 1px solid var(--aside-arrow-bgColor);
  position: fixed;
  top: 50%;
  left: 375px;
  transform: translateY(-50%);
  display: none;
  line-height: 40px;
  cursor: pointer;
  &:hover {
    background-color: var(--aside-arrow-hover-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border-color: transparent;
    border-radius: 16px;
  }

  .el-icon {
    font-weight: 600;
    color: var(--aside-arrow-expand-icon-color);
  }
}
.permission-manage {
  display: flex;
  justify-content: flex-start;
  height: 100%;

  .permission-tree-box {
    margin-right: 16px;
    width: 260px;
    padding: 16px;
    border-radius: 16px;
    background: var(--aside-page-bgColor);
    position: relative;
    transition: width 0.3s;
    &:hover {
      .expaned {
        display: block;
      }
    }

    .permission-tree {
      height: calc(100% - 30px);
      .permission-tree-header {
        display: flex;
        justify-content: space-between;
        line-height: 30px;

        .icon {
          margin-left: 10px;
          color: var(--aside-page-icon-color);
          font-size: 14px;
          cursor: pointer;

          &:hover {
            color: var(--base-primary-bgColor);
          }
        }

        &-title {
          color: var(--aside-page-title-color);
        }
      }
      .common-tree-box {
        height: 100%;
        margin-top: 8px;
      }
    }
  }

  .permission-list-box {
    width: calc(100% - 276px);
    .permission-list-header {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
      background: var(--aside-bg-color);

      p {
        height: 20px;
        line-height: 10px;
        margin: 5px 0px;
        padding: 4px 10px;
        border-left: 4px solid var(--base-primary-color);
      }

      .search-input {
        width: 300px;

        .prepend-select {
          width: 90px;
        }
      }
    }

    .operation-box {
      display: flex;
      justify-content: flex-start;
      text-align: left;
      margin-bottom: 16px;
    }

    .common-table-box {
      user-select: text;
      height: calc(100% - 112px);
      padding: 0 16px;

      .common-button-box {
        display: flex;
        justify-content: flex-start;
        :deep(.el-button:not(:last-child)) {
          margin-right: 32px;
        }

        :deep(.el-button:last-child) {
          margin-left: 0;
        }
      }
    }
  }
}

.openTree {
  width: 0 !important;
  padding: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  border: none;
  .expaned {
    left: 118px !important;
    z-index: 9;
    display: block !important;
  }
}
</style>
